import Papa from "papaparse";
import * as XLSX from "xlsx";
import { ImportInterface } from "../interfaces/Import/importInterfase";
import { v4 } from "uuid";

export const importShipmentsFromCSV = async (file: File) => {
  const result: ImportInterface[] = await new Promise((resolve, reject) => {
    Papa.parse<ImportInterface>(file, {
      header: true,
      complete: (results) => {
        resolve(results.data);
      },
      error: () => {
        reject([]);
      },
    });
  });

  return result;
};

export const importShipmentsFromXLSX = async (file: File) => {
  const result: ImportInterface[] = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const bufferArray = e.target?.result;
        // Security: disable formula/HTML parsing — only read raw cell values.
        // Prevents SheetJS prototype-pollution / formula execution vectors.
        const wb = XLSX.read(bufferArray, {
          type: "buffer",
          cellFormula: false,
          cellHTML: false,
        });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json<ImportInterface>(ws, {
          blankrows: false,
          header: 'A',
          raw: true,
          rawNumbers: true
        });
        data.forEach((row) => {
            row.id= v4()
        });
        resolve(data);
      } catch (err) {
        // Corrupt/malformed file — surface to caller instead of hanging UI.
        reject(err);
      }
    };
    // Without onerror, a failed read leaves the promise pending forever.
    reader.onerror = () => reject(reader.error ?? new Error('FileReader error'));
    reader.readAsArrayBuffer(file);
  });
  return result;
};
